"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCosmos = void 0;
const customers_1 = require("./customers");
const env = process.env.NODE_ENV;
const getCosmos = (key, domain = '', newEnv = '') => {
    const environment = (newEnv) ? newEnv : ((env) ? env : 'production');
    const hostname = (domain) ? domain : ((typeof window !== 'undefined') ? window.location.hostname : '');
    ///////// EDUCABOT /////////
    if (customers_1.customers.EDUCABOT[environment]
        && typeof customers_1.customers.EDUCABOT[environment][key] !== 'undefined'
        && (hostname === 'localhost'
            || hostname === customers_1.customers.EDUCABOT[environment].cosmosFrontUrl
            || hostname === customers_1.customers.EDUCABOT[environment].cosmosBackUrl
            || hostname === customers_1.customers.EDUCABOT[environment].cosmosFrontAnimationsUrl
            || hostname === customers_1.customers.EDUCABOT[environment].cosmosFrontGamesUrl
        // hostname.includes(customers.EDUCABOT[environment].cosmosFrontUrl || hostname === 'localhost')
        // || hostname.includes(customers.EDUCABOT[environment].cosmosBackUrl || hostname === 'localhost')
        )) {
        return customers_1.customers.EDUCABOT[environment][key];
        ///////// CODIT /////////
    }
    else if (customers_1.customers.CODIT[environment]
        && typeof customers_1.customers.CODIT[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.CODIT[environment].cosmosFrontUrl
            || hostname === customers_1.customers.CODIT[environment].cosmosBackUrl
            || hostname === customers_1.customers.CODIT[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.CODIT[environment][key];
        ///////// COPA_ROBOTICA /////////
    }
    else if (customers_1.customers.COPA_ROBOTICA[environment]
        && typeof customers_1.customers.COPA_ROBOTICA[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.COPA_ROBOTICA[environment].cosmosFrontUrl
            || hostname === customers_1.customers.COPA_ROBOTICA[environment].cosmosBackUrl
            || hostname === customers_1.customers.COPA_ROBOTICA[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.COPA_ROBOTICA[environment][key];
        ///////// REV_ROBOTICS /////////
    }
    else if (customers_1.customers.REV_ROBOTICS[environment]
        && typeof customers_1.customers.REV_ROBOTICS[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.REV_ROBOTICS[environment].cosmosFrontUrl
            || hostname === customers_1.customers.REV_ROBOTICS[environment].cosmosBackUrl
            || hostname === customers_1.customers.REV_ROBOTICS[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.REV_ROBOTICS[environment][key];
        ///////// CREATEC /////////
    }
    else if (customers_1.customers.CREATEC[environment]
        && typeof customers_1.customers.CREATEC[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.CREATEC[environment].cosmosFrontUrl
            || hostname === customers_1.customers.CREATEC[environment].cosmosBackUrl
            || hostname === customers_1.customers.CREATEC[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.CREATEC[environment][key];
        ///////// FIFA /////////
    }
    else if (customers_1.customers.FIFA[environment]
        && typeof customers_1.customers.FIFA[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.FIFA[environment].cosmosFrontUrl
            || hostname === customers_1.customers.FIFA[environment].cosmosBackUrl
            || hostname === customers_1.customers.FIFA[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.FIFA[environment][key];
        ///////// FIFA FOUNDATION /////////
    }
    else if (customers_1.customers.FIFA_FOUNDATION[environment]
        && typeof customers_1.customers.FIFA_FOUNDATION[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.FIFA_FOUNDATION[environment].cosmosFrontUrl
            || hostname === customers_1.customers.FIFA_FOUNDATION[environment].cosmosBackUrl
            || hostname === customers_1.customers.FIFA_FOUNDATION[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.FIFA_FOUNDATION[environment][key];
        ///////// CREABOTS /////////
    }
    else if (customers_1.customers.CREABOTS[environment]
        && typeof customers_1.customers.CREABOTS[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.CREABOTS[environment].cosmosFrontUrl
            || hostname === customers_1.customers.CREABOTS[environment].cosmosBackUrl
            || hostname === customers_1.customers.CREABOTS[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.CREABOTS[environment][key];
        ///////// CREABOTS_LANDING /////////
    }
    else if (customers_1.customers.CREABOTS_LANDING[environment]
        && typeof customers_1.customers.CREABOTS_LANDING[environment][key] !== 'undefined'
        && (hostname === customers_1.customers.CREABOTS_LANDING[environment].cosmosFrontUrl
            || hostname === customers_1.customers.CREABOTS_LANDING[environment].cosmosBackUrl
            || hostname === customers_1.customers.CREABOTS_LANDING[environment].cosmosFrontAnimationsUrl)) {
        return customers_1.customers.CREABOTS_LANDING[environment][key];
        ///////// DEFAULT /////////
    }
    else if (customers_1.customers.DEFAULT.development && typeof customers_1.customers.DEFAULT.development[key] !== 'undefined') {
        return customers_1.customers.DEFAULT.development[key];
    }
    else {
        return '';
    }
};
exports.getCosmos = getCosmos;
//# sourceMappingURL=cosmos.js.map